import { Link, type LinkProps } from '@takeshape/redux-little-router';
import React from 'react';

export type MinimalRouterLinkProps = LinkProps;
/**
 * A Router Link which acts like <a></a>. It properly forwards ref and is useful for passing to MUI component properties
 */
export const MinimalRouterLink = React.forwardRef<HTMLAnchorElement, MinimalRouterLinkProps>((props, ref) => (
  <Link {...props} innerRef={ref} />
));
